import React from 'react'
import './RegisteredTeam.css'
import {
  Input,
  Upload,
  Icon,
  Button,
  Form,
  DatePicker,
  Row,
  Col,
  Select,
  message
} from 'antd'
import ComponentCardImg from '@/img/ComponentCard.png'
import PersonImg from '@/img/person.png'
import config from '@/utils/config'
import request from '@/utils/request'
// import Cookies from 'js-cookie' // js-cookie
import { setKey, getKey } from '@/utils/Cookie'
import axios from 'axios'
const { Option } = Select
var myCaptcha = null
class RegisteredTeamForm extends React.Component {
  state = {
    picShow: null,
    picFile: null,
    picShowPerson: null,
    picFilePerson: null,
    codeText: '发送验证码',
    isSendCode: false, //是否能点击
    timer: null,
    count: 60,
    timer: null
  }
  componentDidMount() {
    document.documentElement.scrollTop = document.body.scrollTop = 0

    var that = this
    // eslint-disable-next-line
    myCaptcha = _dx.Captcha(document.getElementById('c1'), {
      style: 'popup',
      appId: 'ebaf330bfcdb7ac9b10a42b9a8e4a474', //appId，在控制台中“应用管理”或“应用配置”模块获取
      success: function(token) {
        // console.log('token:', token)
        myCaptcha.hide()
        myCaptcha.reload()
        request
          .get(`/v1/mobile/messages/slide/code?token=${token}`)
          .then(res => {
            // console.log('res1111')
            // console.log(res)
            if (res == true) {
              request
                .get(`/v1/mobile/messages/reg/${that.state.optionData}/code`)
                .then(res => {
                  // console.log('获取验证码')
                  // console.log(res)
                  message.info(res)

                  that.setState({
                    isSendCode: true
                  })
                  if (!that.state.timer) {
                    const Interval = setInterval(() => {
                      if (that.state.count > 0) {
                        that.setState({
                          codeText: `重发倒计时${that.state.count--}s`
                        })
                      } else {
                        clearInterval(that.state.timer)
                        that.setState({
                          count: 60,
                          timer: null,
                          isSendCode: false,
                          codeText: '重发验证码'
                        })
                      }
                    }, 1000)
                    that.setState({
                      timer: Interval
                    })
                  }
                })
            }
          })
      },
      fail: function(msg) {
        // console.log('token:', msg)
      }
    })
  }
  componentWillMount() {}

  GetPerson() {
    this.props.history.push('/Main/Team/ShowTeamAppointment')
  }
  handleSubmit = e => {
    e.preventDefault()
    // this.GetPerson()
    this.props.form.validateFieldsAndScroll((err, values) => {
      // console.log(values)
      if (!err) {
        // console.log('Received values of form: ', values)
        let formData = new FormData()
        formData.append(`businessLicenseName`, values.businessLicenseName)
        formData.append(`businessLicenseNumber`, values.businessLicenseNumber)
        formData.append(`code`, values.code)
        formData.append(`email`, values.email)
        formData.append(`leaderIdCard`, values.leaderIdCard)
        formData.append(`businessLicenseFile`, this.state.picFile)
        formData.append(`leaderIdCardPositiveFile`, this.state.picFilePerson)
        formData.append(`leaderMobile`, values.leaderMobile)
        formData.append(`leaderName`, values.leaderName)

        // console.log(formData)
        let config = {
          headers: {
            'Content-Type': 'multipart/form-data'
            // 'Content-type': 'application/x-www-form-urlencoded'
          }
        }
        axios
          .post('/v1/mobile/reserve/group/info', formData, config)
          .then(res => {
            // console.log('团队预约')
            // console.log(res)
            if (res == '提交成功') {
              // Cookies.set('businessLicenseNumber', values.businessLicenseNumber)
              setKey('businessLicenseNumber', values.businessLicenseNumber)
              message.success(res)
              this.props.history.push('/Main/Team/ShowTeamAppointment')
            } else {
              message.error(res)
            }
          })
      }
    })
  }
  //返回
  GoBack = () => {
    this.props.history.push('/Main/Team/LogoTeam')
  }
  //自定义上传
  customRequest = option => {
    // console.log(option)
    //生成一个图片路径(使用URL.createObjectURL将选择的图片生成一个路径)
    var imgSrc = URL.createObjectURL(option.file)
    // console.log(imgSrc)
    this.setState({
      picShow: imgSrc,
      picFile: option.file
    })
  }
  customRequestPerson = option => {
    // console.log(option)
    //生成一个图片路径(使用URL.createObjectURL将选择的图片生成一个路径)
    var imgSrc = URL.createObjectURL(option.file)
    console.log(imgSrc)
    this.setState({
      picShowPerson: imgSrc,
      picFilePerson: option.file
    })
  }
  //获取短信验证码
  GetCode = () => {
    // console.log('验证码')
    // console.log(this.props.form.getFieldsValue)
    // console.log(this.props.form.getFieldValue('leaderMobile'))

    // this.getFieldsValue = this.props.form.getFieldsValue;//获得表单所有控件的值
    // this.props.form.getFieldValue('phone')//获得指定控件的值

    let loginName = this.props.form.getFieldValue('leaderMobile')
    if (!loginName || !config.regExp.phone.test(loginName)) {
      message.info('请输入正确的手机号码')
      return
    }

    this.setState({
      optionData: loginName
    })
    myCaptcha.show()
    // getMobileCode(loginName).then(res => {
    //   if (res.status == 200) {
    //     this.$message.success(res.data)
    //     this.isSendCode = true

    // this.setState({
    //   isSendCode: true
    // })
    // if (!this.state.timer) {
    //   const Interval = setInterval(() => {
    //     if (this.state.count > 0) {
    //       this.setState({
    //         codeText: `重发倒计时${this.state.count--}s`
    //       })
    //     } else {
    //       clearInterval(this.state.timer)
    //       this.setState({
    //         count: 60,
    //         timer: null,
    //         isSendCode: false,
    //         codeText: '重发验证码'
    //       })
    //     }
    //   }, 1000)
    //   this.setState({
    //     timer: Interval
    //   })
    // }

    //   }
    // })
  }
  render() {
    const { getFieldDecorator } = this.props.form
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      }
    }
    const formItemLayoutItem = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 12 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 }
      }
    }
    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0
        },
        sm: {
          span: 16,
          offset: 8
        }
      }
    }
    const { codeText, isSendCode } = this.state
    return (
      <div className="RegisteredTeam">
        <div className="RegisteredTeam_title">
          <div className="back" onClick={el => this.GoBack()}>
            返回
          </div>
          <div className="title">
            企事业单位注册
            <span>></span>
            注册详情
          </div>
        </div>
        <div className="RegisteredTeam_AddConten addPerson">
          <Form {...formItemLayout} onSubmit={this.handleSubmit}>
            <Form.Item label={<span>企事业单位名称</span>}>
              {getFieldDecorator('businessLicenseName', {
                rules: [
                  {
                    required: true,
                    message: '请输入企事业单位名称',
                    whitespace: true
                  }
                ]
              })(<Input placeholder="请输入企事业单位名称" />)}
            </Form.Item>
            <Form.Item label={<span>社会统一信用代码</span>}>
              {getFieldDecorator('businessLicenseNumber', {
                rules: [
                  {
                    required: true,
                    message: '请输入社会统一信用代码',
                    whitespace: true
                  }
                ]
              })(<Input placeholder="请输入社会统一信用代码" />)}
            </Form.Item>
            <Form.Item label="上传营业执照：">
              {getFieldDecorator('businessLicenseFile', {
                rules: [{ required: true, message: '营业执照不能为空！' }]
              })(
                <Upload.Dragger
                  name="files"
                  action=""
                  showUploadList={false}
                  customRequest={this.customRequest}
                >
                  <div className="ImgContent">
                    <div className="ContentImg">
                      {this.state.picShow ? (
                        <div
                          style={{
                            width: '224px',
                            height: '139px',
                            background: '#fafafa'
                          }}
                        >
                          <img
                            style={{ height: '139px' }}
                            src={this.state.picShow}
                          ></img>
                        </div>
                      ) : (
                        <div
                          style={{
                            width: '224px',
                            height: '139px',
                            background: '#fafafa'
                          }}
                        >
                          <p className="ant-upload-drag-icon">
                            <img
                              style={{
                                width: '65px',
                                height: '71px',
                                marginTop: '14px'
                              }}
                              src={ComponentCardImg}
                            ></img>
                          </p>
                          <p
                            className="ant-upload-text"
                            style={{ fontSize: '12px', color: '#666' }}
                          >
                            请上传营业执照
                          </p>
                        </div>
                      )}
                    </div>
                    <div className="ContentRight">
                      <div className="ant-upload-hint" style={{ padding: '0' }}>
                        请上传jpg、jpeg、png、gif的图片格式，图片大小不超过700kb。
                      </div>
                    </div>
                  </div>
                  {/* {this.state.picShow ? (
                    <img
                      style={{ width: '280px', height: '314px' }}
                      src={this.state.picShow}
                    ></img>
                  ) : (
                    <div>
                      <p className="ant-upload-drag-icon">
                        <img
                          style={{ height: '80px' }}
                          src={ComponentCardImg}
                        ></img>
                      </p>
                      <p className="ant-upload-text">请上传营业执照</p>
                      <div
                        className="ant-upload-hint"
                        style={{ padding: '0 20px' }}
                      >
                        请上传jpg、jpeg、png、gif的图片格式，图片大小不超过700kb。
                      </div>
                    </div>
                  )} */}
                </Upload.Dragger>
              )}
            </Form.Item>

            <Form.Item label={<span>联系人姓名</span>}>
              {getFieldDecorator('leaderName', {
                rules: [
                  {
                    required: true,
                    message: '请输入联系人姓名',
                    whitespace: true
                  }
                ]
              })(<Input placeholder="请输入联系人姓名" />)}
            </Form.Item>
            <Form.Item label="联系人身份证号：">
              {getFieldDecorator('leaderIdCard', {
                rules: [{ required: true, message: '请输入联系人身份证号' }]
              })(<Input placeholder="请输入联系人身份证号" />)}
            </Form.Item>
            <Form.Item label="身份证图片：">
              {getFieldDecorator('leaderIdCardPositiveFile', {
                rules: [{ required: true, message: '身份证图片不能为空！' }]
              })(
                <Upload.Dragger
                  name="files"
                  action=""
                  showUploadList={false}
                  customRequest={this.customRequestPerson}
                >
                  <div className="ImgContent">
                    <div className="ContentImg">
                      {this.state.picShowPerson ? (
                        <div
                          style={{
                            width: '224px',
                            height: '139px',
                            background: '#fafafa'
                          }}
                        >
                          <img
                            style={{ height: '139px' }}
                            src={this.state.picShowPerson}
                          ></img>
                        </div>
                      ) : (
                        <div
                          style={{
                            width: '224px',
                            height: '139px',
                            background: '#fafafa'
                          }}
                        >
                          <p className="ant-upload-drag-icon">
                            <img
                              style={{
                                width: '65px',
                                height: '71px',
                                marginTop: '14px'
                              }}
                              src={PersonImg}
                            ></img>
                          </p>
                          <p
                            className="ant-upload-text"
                            style={{ fontSize: '12px', color: '#666' }}
                          >
                            请上传预约人正面人脸照片
                          </p>
                        </div>
                      )}
                    </div>
                    <div className="ContentRight">
                      <div className="ant-upload-hint" style={{ padding: '0' }}>
                        请上传jpg、jpeg、png、gif的图片格式，图片大小不超过700kb。
                      </div>
                    </div>
                  </div>

                  {/* {this.state.picShowPerson ? (
                    <img
                      style={{ width: '280px', height: '314px' }}
                      src={this.state.picShowPerson}
                    ></img>
                  ) : (
                    <div>
                      <p className="ant-upload-drag-icon">
                        <img style={{ height: '80px' }} src={PersonImg}></img>
                      </p>
                      <p className="ant-upload-text">请上传身份证人像面</p>
                      <div
                        className="ant-upload-hint"
                        style={{ padding: '0 20px' }}
                      >
                        请上传jpg、jpeg、png、gif的图片格式，图片大小不超过700kb。
                      </div>
                    </div>
                  )} */}
                </Upload.Dragger>
              )}
            </Form.Item>
            <Form.Item label="团队预留邮箱：">
              {getFieldDecorator('email', {
                rules: [{ required: true, message: '请输入团队预留邮箱' }]
              })(
                <Input
                  placeholder="请输入团队预留邮箱"
                  style={{ width: '100%' }}
                />
              )}
            </Form.Item>

            <Form.Item label="联系人电话：">
              {getFieldDecorator('leaderMobile', {
                rules: [{ required: true, message: '请输入联系人电话' }]
              })(
                <Input
                  placeholder="请输入联系人电话"
                  style={{ width: '100%' }}
                />
              )}
            </Form.Item>
            <Row>
              <Col span={16}>
                <Form.Item label="短信验证：" {...formItemLayoutItem}>
                  {getFieldDecorator('code', {
                    rules: [{ required: true, message: '请输入短信验证码' }]
                  })(<Input placeholder="请输入短信验证码" />)}
                </Form.Item>
              </Col>
              <Col span={8}>
                <Button
                  type="primary"
                  disabled={isSendCode}
                  className="CodeButton"
                  onClick={el => this.GetCode()}
                >
                  {codeText}
                </Button>
              </Col>
            </Row>

            <Form.Item {...tailFormItemLayout}>
              {/* <Button type="primary" htmlType="submit">
                立即预约
              </Button> */}
              <div className="RegisteredTeam_footer">
                <Button
                  className="RegisteredTeam_footer_button"
                  // onClick={el => this.GetPerson()}
                  htmlType="submit"
                >
                  提交注册信息
                </Button>
              </div>
            </Form.Item>
          </Form>
          <div className="ccc">
            <div id="c1" ref="myInput"></div>
          </div>
        </div>
      </div>
    )
  }
}
const RegisteredTeam = Form.create()(RegisteredTeamForm)
export default RegisteredTeam
